export const users = [
  {
    id: "1",
    name: "Jack Schaefer",
    username: "jack@saturn.com",
    email: "jack@saturn.com",
    avatar: "/avatars/jack.png",
    role: "administrator",
  },
  {
    id: "2",
    name: "John Doe",
    username: "john@saturn.com",
    email: "john@saturn.com",
    avatar: "/avatars/john.png",
    role: "administrator",
  },
];

export const rootUser = users[0];
